import 'reflect-metadata';
import './styles/global.scss';
import './preload';

// @ts-ignore
import QATools from '@/components/QATools';
import SentryErrorBoundary from '@/components/SentryErrorBoundary';
import { ENV } from '@env';
import { initSentry, Sentry } from '@marpla/core';
import { ApplicationErrorBoundary } from '@marpla/core/application-error';
import { CoreEnvResolver } from '@marpla/core/env.resolver';
import SnackbarProvider from '@marpla/ui/components/SnackbarProvider';
import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { enableMapSet } from 'immer';
import ReactDOM from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import '@marpla/ui/index.css';

import App from './app/index';
import { store } from './redux/store';
import theme from './theme';
import { disableDataGridLicenseError } from './utils/utils';

CoreEnvResolver.setEnvironment(ENV);

const isSentryEnabled = initSentry({
  dsn: __SENTRY_DSN__,
  environment: ENV,
  moduleName: 'seo',
  release: __SENTRY_RELEASE__,
});

if (isSentryEnabled) {
  Sentry.addEventProcessor((event) => {
    if (event.extra?.arguments) {
      delete event.extra.arguments;
    }

    event.breadcrumbs = event.breadcrumbs?.map((breadcrumb) => {
      if (breadcrumb.category !== 'console' || !breadcrumb.data?.arguments) {
        return breadcrumb;
      }

      const data = { ...breadcrumb.data };
      delete data.arguments;

      return { ...breadcrumb, data };
    });

    return event;
  });
}

enableMapSet();
disableDataGridLicenseError();

document.addEventListener('DOMContentLoaded', () => {
  const rootEl = document.getElementById('root')!;
  const root = ReactDOM.createRoot(rootEl);
  const content = (
    <ReduxProvider store={store}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <StyledEngineProvider injectFirst>
            <SnackbarProvider>
              <CssBaseline />
              <App />
              <QATools />
            </SnackbarProvider>
          </StyledEngineProvider>
        </BrowserRouter>
      </ThemeProvider>
    </ReduxProvider>
  );

  root.render(
    <ApplicationErrorBoundary homeHref="/report/project" isSupportChatEnabled>
      {isSentryEnabled ? <SentryErrorBoundary>{content}</SentryErrorBoundary> : content}
    </ApplicationErrorBoundary>,
  );
});
